<template>
  <ValidationProvider
    :rules="rules"
    :name="fieldId"
    class="form-group"
    tag="div"
    v-slot="{ errors, validate }"
  >
    <label class="control-label col-sm-2" :for="fieldId">
      {{ name }}
      <span class="text-danger" v-if="required">*</span>
    </label>
    <div class="col-sm-9">
      <label class="btn btn-secondary btn-file" :title="tooltip">
        Parcourir
        <input
          type="file"
          :id="fieldId"
          :name="fieldId"
          @change="validate($event) && onChange($event)"
          :required="required"
          :disabled="!enabled"
          accept="image/*, application/pdf, text/csv, text/plain, audio/*, video/*, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/rtf"
        />
      </label>
      <span class="file-name">{{ fileName }}</span>
      <small class="text-muted input-description">{{ description }}</small>
      <div>
        <small
          v-for="error in errors"
          :key="error"
          class="text-danger input-error"
          >{{ error }}</small
        >
      </div>
    </div>
  </ValidationProvider>
</template>

<script>
import Vue from "vue";
import { ValidationProvider } from "vee-validate";

export default Vue.extend({
  name: "file-field",
  components: {
    ValidationProvider
  },
  data() {
    return {
      fileName: null
    };
  },
  props: {
    fieldId: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    tooltip: String,
    description: String,
    required: {
      type: Boolean,
      default: false
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onChange(event) {
      const file = event.target.files[0];
      this.fileName = file.name;
      this.$emit("change", file);
    }
  },

  computed: {
    rules() {
      const rules = {};
      if (this.required) {
        rules["required"] = true;
      }
      return rules;
    }
  }
});
</script>

<style scoped>
.input-description {
  display: flex;
}
.file-name {
  margin-left: 20px;
}
</style>
